<template>
  <form @submit.prevent="save" class="ortic-form-horizontal">
    <o-card>
      <b-tabs class="inline-tabs" ref="tabs" v-model="activeTab">
        <b-tab :title="$t('sandoz.chargeback_request_wholesaler')" active>
          <b-row>
            <b-col>
              <o-value-select :readonly="readOnly" :label="$t('sandoz.requestor')" url="/api/system/users?filter%5Bactive%5D=1%25&sortBy=name&per_page=99999&include=regions" value-field="id" text-field="name" v-model="item.user_id" @input-object="setCurrentUser"></o-value-select>
							<o-datepicker :readonly="true" :label="$t('sandoz.request_date')" v-model="item.chargeback_date"/>
							<o-value-select v-model="item.chargeback_year" :items="years" :label="$t('sandoz.year')"
                :title="$t('sandoz.year')"/>

								<o-value-select :readonly="readOnly" :label="$t('sandoz.wholesaler')" url="/api/wholesalers?filter%5Benabled_for_chargebacks%5D=1&per_page=999&sortBy=wholesaler" value-field="id" text-field="dwh_name" v-model="item.wholesaler1" @input-object="setWholesaler"></o-value-select>
            </b-col>
						<b-col>

						</b-col>
          </b-row>
          <b-btn @click.prevent="activeTab++">{{$t('sandoz.next')}}</b-btn>
        </b-tab>
        <b-tab :title="$t('sandoz.kuko_condition_information')">
          <b-row>
            <b-col>
              <b-form-checkbox v-model="item.condition_categories" :disabled="readOnly" value="otcProducts">{{ $t('sandoz.products') }}</b-form-checkbox>
              <b-form-checkbox v-model="item.condition_categories" :disabled="readOnly" value="materialGroup">{{ $t('sandoz.material_group') }}</b-form-checkbox>
              <b-form-checkbox v-model="item.condition_categories" :disabled="internalRebateDisabled" value="portfolioRebate">{{ $t('sandoz.portfolio_rebate') }}</b-form-checkbox>
            </b-col>
            <b-col cols="4" align-self="center" v-if="item.condition_categories && item.condition_categories.length">
            </b-col>
          </b-row>
          <b-row>
            <b-col v-if="item.condition_categories && item.condition_categories.includes('otcProducts')" xl="12">
              <hr>
              <strong>{{$t('sandoz.products')}}</strong>

              <div class="mt-3 d-flex">
                <b-btn variant="primary" v-if="!readOnly" @click.prevent="addProduct">{{$t('sandoz.add_product')}}</b-btn>
                <b-btn variant="primary" v-if="!readOnly" class="ml-1" @click.prevent="addProductByGln">{{$t('sandoz.add_product_by_gln')}}</b-btn>
                <o-attachment :disabled="readOnly" v-model="item.otc_product_attachments"
                              :label="$t('core.attachments')"
                              :save-url="'/api/chargebacks/attachments/upload'" :delete-url="'/api/chargebacks/attachments/delete'"
                              :download-url="'/api/chargebacks/attachments/download/'"
                              type="otc_product_attachments" @action="addOtcAttachment">
                </o-attachment>
              </div>

              <div class="d-flex">
                <table class="table table-sm" v-if="item.condition_products.length > 0">
                  <thead>
                    <tr>
                      <th>{{$t('sandoz.product')}}</th>
                      <th>{{$t('sandoz.gln')}}</th>
                      <th width="130">{{$t('sandoz.yearly_gross_sales')}}</th>
                      <th width="130">{{$t('sandoz.chargeback_chf')}}</th>
                      <th width="200">{{$t('sandoz.chargeback_per')}}</th>
                      <th width="200">{{$t('sandoz.fixed_chargeback')}}</th>
                      <th width="200">{{$t('sandoz.passthrough_chargeback')}}</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <template v-for="(product, productIndex) in item.condition_products">
                      <tr>
                        <td>{{product.kuko_product.product}}</td>
                        <td :title="product.kuko_product.pharma_code">{{product.kuko_product.gln}}</td>
                        <td width="130">
													<o-input-control v-model.number="product.yearly_gross_sales" format="number" @input="calChargeback(product)"/>
                        </td>
                        <td width="130">
													<o-input-control v-model.number="product.chargeback_chf" readonly format="number"/>
                        </td>
                        <td width="200">
													<b-input-group append="%">
                            <o-input-percentage-control v-model.number="product.chargeback_percentage" :readonly="readOnly"
                                                        :min="0.01" :max="99.99" :only-integer="false" @input="calChargeback(product)"/>
                            </o-input-percentage-control>
                          </b-input-group>
                        </td>
                        <td width="200">
													<o-input-control v-model.number="product.fixed_chargeback" format="number"/>
                        </td>
                        <td width="200">
                          <o-input-control v-model.number="product.passthrough_chargebacks" format="number"/>
                        </td>
                        <td class="text-right">
                          <o-delete :small="true" v-if="!readOnly" v-on:execute-action="item.condition_products.splice(productIndex, 1); loadProductKpis()"></o-delete>
                        </td>
                      </tr>
                    </template>
                  </tbody>
                </table>
                <table class="w-50" v-else>
                  <tr>
                    <td>{{$t('sandoz.please_add_products')}}</td>
                  </tr>
                </table>
              </div>
            </b-col>
            <b-col v-if="item.condition_categories && item.condition_categories.includes('materialGroup')" xl="12">
              <hr>
              <strong>{{$t('sandoz.material_group')}}</strong>

              <div class="mt-3 d-flex">
              </div>

              <div class="">
                <div>
                  <table class="table table-sm" v-if="item.condition_product_groups.length > 0">
                    <thead>
                      <tr>
                        <th>{{$t('sandoz.product_group')}}</th>
                        <th width="130">{{$t('sandoz.yearly_gross_sales')}}</th>
												<th width="130">{{$t('sandoz.chargeback_chf')}}</th>
												<th width="200">{{$t('sandoz.chargeback_per')}}</th>
												<th width="200">{{$t('sandoz.fixed_chargeback')}}</th>
                        <th width="200">{{$t('sandoz.passthrough_chargeback')}}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <template v-for="(productGroup, productGroupIndex) in item.condition_product_groups.filter(w => w.kuko_product_group.product_group_category === 'normal')">
                        <tr>
                          <td>
                            <label @click.prevent="item.condition_product_groups.splice(filterConditionProductGroup(productGroup.product_group_id), 1)">
                              <input type="checkbox" checked>
                              <span v-html="productGroup.kuko_product_group.description_scheme"></span>
                            </label>
                          </td>
													<td width="130">
														<o-input-control v-model.number="productGroup.yearly_gross_sales" format="number" @input="calChargeback(productGroup)"/>
													</td>
													<td width="130">
														<o-input-control v-model.number="productGroup.chargeback_chf" readonly/>
													</td>
													<td width="200">
														<b-input-group append="%">
															<o-input-percentage-control v-model.number="productGroup.chargeback_percentage" :readonly="readOnly"
																													:min="0.01" :max="99.99" :only-integer="false" @input="calChargeback(productGroup)">
															</o-input-percentage-control>
														</b-input-group>
													</td>
													<td width="200">
														<o-input-control v-model.number="productGroup.fixed_chargeback" format="number"/>
													</td>
                          <td width="130">
                            <o-input-control v-model.number="productGroup.passthrough_chargebacks" format="number"/>
                          </td>
                        </tr>
                      </template>
                    </tbody>
                  </table>
                  <table class="table table-sm" v-if="!readOnly">
                    <tbody>
                      <template v-for="(productGroup, productGroupIndex) in productGroups">
                        <tr :key="productGroup.id" v-if="productGroup.product_group_category === 'normal' && item.condition_product_groups.filter(w => w.product_group_id == productGroup.id).length == 0">
                          <td>
                            <label>
                              <input type="checkbox" @click="productGroup.warning ? $bvModal.show('modal-warning-2-' + productGroupIndex): addProductGroup(productGroup, item)">
                              <span v-html="productGroup.description_scheme"></span>
                            </label>
                            <b-modal hide-header-close header-text-variant="danger" :title="$t('sandoz.warning')" :id="'modal-warning-2-' + productGroupIndex" @ok="addProductGroup(productGroup, item)">
                              <div v-if="productGroup" v-html="productGroup.warning"></div>
                            </b-modal>
                          </td>
                        </tr>
                      </template>
                    </tbody>
                  </table>
                </div>
              </div>
            </b-col>
            <b-col v-if="item.condition_categories && item.condition_categories.includes('portfolioRebate')" xl="12">
              <hr>
              <strong>{{$t('sandoz.portfolio_rebate')}}</strong>
              <br><br>
              <strong>{{$t('sandoz.pr_small_molecules')}}</strong>
              <table class="table table-sm mt-3">
                <thead>
                  <tr>
										<th width="130">{{$t('sandoz.yearly_gross_sales')}}</th>
										<th width="130">{{$t('sandoz.chargeback_chf')}}</th>
										<th width="200">{{$t('sandoz.chargeback_per')}}</th>
										<th width="200">{{$t('sandoz.fixed_chargeback')}}</th>
                    <th width="200">{{$t('sandoz.passthrough_chargeback')}}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
										<td width="130">
											<o-input-control v-model.number="item.portfolio_rebate_yearly_gross_sales" format="number" @input="calChargeback1(item)"/>
										</td>
										<td width="130">
											<o-input-control v-model.number="item.portfolio_rebate_chargeback_chf" readonly format="number"/>
										</td>
										<td width="200">
											<b-input-group append="%">
												<o-input-percentage-control v-model.number="item.portfolio_rebate_chargeback_percentage" :readonly="readOnly"
																										:min="0.01" :max="99.99" :only-integer="false" @input="calChargeback1(item)">
												</o-input-percentage-control>
											</b-input-group>
										</td>
										<td width="200">
											<o-input-control v-model.number="item.portfolio_rebate_fixed_chargeback" format="number"/>
										</td>
                    <td width="200">
                      <o-input-control v-model="item.portfolio_rebate_passthrough_chargeback" />
                    </td>
                  </tr>
                </tbody>
              </table>
              <strong>{{$t('sandoz.pr_biosimilars')}}</strong>
              <table class="table table-sm mt-3">
                <thead>
                <tr>
                  <th width="130">{{$t('sandoz.yearly_gross_sales')}}</th>
                  <th width="130">{{$t('sandoz.chargeback_chf')}}</th>
                  <th width="200">{{$t('sandoz.chargeback_per')}}</th>
                  <th width="200">{{$t('sandoz.fixed_chargeback')}}</th>
                  <th width="200">{{$t('sandoz.passthrough_chargeback')}}</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <td width="130">
                    <o-input-control v-model.number="item.bio_portfolio_rebate_yearly_gross_sales" format="number" @input="calChargeback1(item, 'bio_')"/>
                  </td>
                  <td width="130">
                    <o-input-control v-model.number="item.bio_portfolio_rebate_chargeback_chf" readonly format="number"/>
                  </td>
                  <td width="200">
                    <b-input-group append="%">
                      <o-input-percentage-control v-model.number="item.bio_portfolio_rebate_chargeback_percentage" :readonly="readOnly"
                                                  :min="0.01" :max="99.99" :only-integer="false" @input="calChargeback1(item, 'bio_')">
                      </o-input-percentage-control>
                    </b-input-group>
                  </td>
                  <td width="200">
                    <o-input-control v-model.number="item.bio_portfolio_rebate_fixed_chargeback" format="number"/>
                  </td>
                  <td width="200">
                    <o-input-control v-model="item.bio_portfolio_rebate_passthrough_chargeback" />
                  </td>
                </tr>
                </tbody>
              </table>
              <strong>{{$t('sandoz.pr_others')}}</strong>
              <table class="table table-sm mt-3">
                <thead>
                <tr>
                  <th width="130">{{$t('sandoz.yearly_gross_sales')}}</th>
                  <th width="130">{{$t('sandoz.chargeback_chf')}}</th>
                  <th width="200">{{$t('sandoz.chargeback_per')}}</th>
                  <th width="200">{{$t('sandoz.fixed_chargeback')}}</th>
                  <th width="200">{{$t('sandoz.passthrough_chargeback')}}</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <td width="130">
                    <o-input-control v-model.number="item.other_portfolio_rebate_yearly_gross_sales" format="number" @input="calChargeback1(item, 'other_')"/>
                  </td>
                  <td width="130">
                    <o-input-control v-model.number="item.other_portfolio_rebate_chargeback_chf" readonly format="number"/>
                  </td>
                  <td width="200">
                    <b-input-group append="%">
                      <o-input-percentage-control v-model.number="item.other_portfolio_rebate_chargeback_percentage" :readonly="readOnly"
                                                  :min="0.01" :max="99.99" :only-integer="false" @input="calChargeback1(item, 'other_')">
                      </o-input-percentage-control>
                    </b-input-group>
                  </td>
                  <td width="200">
                    <o-input-control v-model.number="item.other_portfolio_rebate_fixed_chargeback" format="number"/>
                  </td>
                  <td width="200">
                    <o-input-control v-model="item.other_portfolio_rebate_passthrough_chargeback" />
                  </td>
                </tr>
                </tbody>
              </table>
            </b-col>
          </b-row>
          <div class="mt-3">
            <b-btn @click.prevent="activeTab--">{{$t('sandoz.previous')}}</b-btn>
            <b-btn @click.prevent="activeTab++">{{$t('sandoz.next')}}</b-btn>
          </div>
        </b-tab>
        <b-tab :title="$t('sandoz.kuko_additional_information')">
          <b-row>
            <b-col>
              <o-textarea :readonly="readOnly" :label="$t('sandoz.additional_comments')" v-model="item.comments"/>
            </b-col>
            <b-col>
              <o-input :readonly="readOnly" :label="$t('sandoz.chargeback_expected_discount')" v-model="item.discount_lower_100" prepend="CHF"/>
              <div v-if="item.discount_lower_100 < 100 && item.discount_lower_100 > 0">
                <div class="text-danger" v-if="!item.expected_discount_note">{{$t('sandoz.expected_discount_note_required')}}</div>
                <o-textarea :readonly="readOnly" :label="$t('sandoz.chargeback_expected_discount_note')" v-model="item.discount_lower_100_note"/>
              </div>
            </b-col>
          </b-row>

          <div class="mt-3">
            <b-btn @click.prevent="activeTab--">{{$t('sandoz.previous')}}</b-btn>
            <b-btn @click.prevent="activeTab++">{{$t('sandoz.next')}}</b-btn>
          </div>
        </b-tab>
        <b-tab :title="$t('sandoz.files')">
          <div class="table-responsive">
            <table class="table">
              <thead>
              <tr>
                <th colspan="5" class="pdfFiles">{{ $t('sandoz.user_files') }}</th>
              </tr>
              <tr>
                  <th class="col-sm-1">{{$t('core.id')}}</th>
                  <th class="col-sm-5">{{$t('sandoz.file_name')}}</th>
                  <th class="col-sm-2">{{$t('sandoz.user')}}</th>
                  <th class="col-sm-2">{{$t('sandoz.date')}}</th>
                  <th class="col-sm text-right">
                      <b-form-file  class="d-none" v-model="wordfile" ref="fileinput" @change="addToWordFiles" accept=".doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document" plain></b-form-file>
                      <b-btn @click.prevent="addFile()" variant="primary">
                        <fa icon="plus"/>
                      </b-btn>
                  </th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(file, i) in item.files">
                <td>{{file.id}}</td>
                <td>
                  <div aria-label="edit controls" class="btn-group btn-group-sm" role="group">
                    <o-button type="button" variant="primary" @click.prevent="word(i)">
                      <fa :icon="getExtension(file.file_name.name)"/>
                    </o-button>
                  </div>
                  {{file.file_name ? file.file_name.name: null}}
                </td>
                <td>{{file.user ? file.user.name: null}}</td>
                <td>{{file.created_at | formatDate}}</td>
                <td class="text-right text-nowrap">
                  <div aria-label="edit controls" class="btn-group btn-group-sm" role="group">
                    <b-btn @click.prevent="deleteWordFile(file.id, i)"
                            variant="secondary">
                      <fa icon="times"/>
                    </b-btn>
                  </div>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
          <b-btn @click.prevent="activeTab--">{{$t('sandoz.previous')}}</b-btn>
        </b-tab>
      </b-tabs>
    </o-card>

    <kuko-product-search ref="kukoProductSearch" @product-selected="productSelected"></kuko-product-search>
		<b-modal ref="errorModal" ok-only :title="$t('sandoz.errors')">
      <ul>
        <li v-for="validationError in validationErrors" :key="validationError">
          {{validationError}}
        </li>
      </ul>
    </b-modal>
    <o-action-toolbar>
      <div class="d-flex w-100">
        <o-button variant="outline-primary" @click.prevent="back">{{$t('sandoz.back_to_archive')}}</o-button>
        <div class="ml-auto">
          <o-button variant="primary" :loading="saving" @click.prevent="save">{{$t('core.save')}}</o-button>
        </div>
      </div>
    </o-action-toolbar>
  </form>
</template>

<script>
  import { mapGetters } from 'vuex'
  import axios from 'axios'
  import KukoProductSearch from '../kukos/partials/KukoProductSearch.vue'
  import { getDefaultStartDate, getDefaultEndDate, contractYears, getCurrentYear } from '../../utils/contractYear'
  import qs from 'qs'
  var moment = require('moment-timezone')

  export default {
    data: () => ({
      loaded: false,
      validationErrors: [],
      saving: false,
      trueValue: true,
      wholesalers: [],
      productGroups: [],
      maximumCustomers: 50,
      activeTab: 0,
      item: {
        external_id: null,
        user_id: null,
        condition_categories: [],
        condition_product_groups: [],
        account_category: '',
        wholesalers: [],
        customer_external_id:null
      },
      kukoProductSearchMode: '',
      years: [],
      wordfile : null,
      conditionGroups: [],
      conditionOutSideErrors: {
        otcProducts: [],
        materialGroup: [],
        portfolioRebate: []
      }
    }),
    components: {
      KukoProductSearch
    },
    created() {
      this.years = contractYears()
    },
    mounted() {
      this.loadData()
    },
    computed: {
      ...mapGetters({
        user: 'auth/user'
      }),
      debug() {
        return 'debug' in this.$route.query
      },
      isNew() {
        return !('id' in this.item)
      },
      internalRebateDisabled() {
        if (this.readOnly) {
          return true
        }
        /*
        // we already have it enabled, useful for existing KUKOs that were created wrongly
        if (this.item.condition_categories.includes('portfolioRebate') || this.item.condition_categories.includes('volumeRebate')) {
          return false
        }
        // We only allow alloga, as long as we have multiple wholesalers selected, it's not allowed
        if (this.item.wholesalers.length != 1) {
          return true
        }
        // not alloga, disable it
        if (this.item.wholesalers[0].wholesaler.wholesaler != 'Alloga AG') {
          return true
        }
        */
        // enabled
        return false
      },
      readOnly() {
        if (!this.item) {
          return true
        }
        // if (this.item.status == 'Draft' || this.item.status == 'Feedback') {
        //   return false
        // }
        return false
      }
    },
    methods: {
      back() {
        if (this.$route.path == this.$router.history._startLocation) {
          this.$router.push({name: 'sandoz.chargeback.list'})
        } else {
          this.$router.back()
        }
      },
      conditionGroupSelected() {
        if(this.item.external_id) {
          var filterGroup = this.conditionGroups.filter(c => c.value === this.item.external_id)
          if(filterGroup && Object.keys(filterGroup).length > 0) {
            this.item.address1 = filterGroup[0].text
          }
        } else {
            this.item.address1 = null
            this.item.external_id = null
        }
      },
      validateForm() {
        var errors = []
        if (!this.item.wholesaler1) {
          errors.push(this.$t('sandoz.please_select_wholesaler'))
        }


        if (this.item.condition_categories.includes('otcProducts')) {
          if (this.item.condition_products.length == 0) {
            errors.push(this.$t('sandoz.please_select_one_otc_product'))
          }
          else {
						if (this.item.condition_products.filter(c => !c.fixed_chargeback && !c.chargeback_chf).length > 0) {
							errors.push(this.$t('sandoz.missing_value', {'field': this.$t('sandoz.otc_chargeback_chf')}))
							errors.push(this.$t('sandoz.missing_value', {'field': this.$t('sandoz.otc_fixed_chargeback')}))
						}
          }
        }
        if (this.item.condition_categories.includes('materialGroup')) {
          if (this.item.condition_product_groups.length == 0) {
            errors.push(this.$t('sandoz.please_select_one_product_group'))
          }
          else {
              if (this.item.condition_product_groups.filter(c => !c.fixed_chargeback && !c.chargeback_chf).length > 0) {
								errors.push(this.$t('sandoz.missing_value', {'field': this.$t('sandoz.material_chargeback_chf')}))
								errors.push(this.$t('sandoz.missing_value', {'field': this.$t('sandoz.material_fixed_chargeback')}))
              }
          }
        }
				if (!this.item.discount_lower_100) {
					errors.push(this.$t('sandoz.missing_value', {'field': this.$t('sandoz.expected_discount')}))
				}
				else {
					if (this.item.discount_lower_100 < 100 && !this.item.discount_lower_100_note) {
						errors.push(this.$t('sandoz.missing_value', {'field': this.$t('sandoz.expected_discount_note')}))
					}
				}
        return errors
      },
      save() {
				this.validationErrors = this.validateForm()
				if (this.validationErrors.length > 0) {
					this.$refs.errorModal.show()
					return
				}


        var url = this.url
        var route = this.$route

        // this happens if we create a new data record and update it right away without navigating way. We'll still have
        // new in our url, but we don't want to create a new record, we want to update the record we just created.
        // @TODO we should do this in a more elegant way that doesn't require search & replace
        if (url.indexOf('/new') > 0 && 'id' in this.item) {
          url = url.replace('/new', '/' + this.item.id)
        }

        var root = this.$root
        var self = this
				this.saving = true

        axios
          .post(url, this.item)
          .then((response) => {
            this.item = response.data

            // assign our new id to the route params in case someone wants to work with it
            if ('id' in response.data) {
              route.params.id = response.data.id
            }

            this.loadedApprovalSteps = this.item.approval_steps
            this.$notify({
              title: this.$i18n.t('core.saved'),
              text: this.$i18n.t('core.saved_text')
            })

            // remove all error states
            var elements = document.querySelectorAll('.has-error')
            elements.forEach((element) => {
              element.classList.remove('has-error')
            })

            // clear all errors
            root.errors = {}

            // stop loading indicator
            self.saving = false
          })
          .catch((error) => {
            // stop loading indicator
            self.saving = false

            if (error.response.status === 422 && 'data' in error.response && 'message' in error.response.data) {
              this.$notify({
                title: this.$i18n.t('core.validation_error'),
                text: this.$i18n.t('core.validation_error_text', {message: error.response.data.message}),
                type: 'error'
              })
              if ('data' in error.response && 'errors' in error.response.data) {
                root.errors = error.response.data.errors
              }
            } else {
              this.$notify({
                title: this.$i18n.t('core.save_error'),
                text: this.$i18n.t('core.save_error_text', {url: this.url}),
                type: 'error'
              })
            }
          })
      },
      addSpecialProduct() {
        this.kukoProductSearchMode = 'condition_special_products'
        this.$refs.kukoProductSearch.showProductSearchModal(this)
      },
      addProduct() {
        this.kukoProductSearchMode = 'condition_products'
        this.$refs.kukoProductSearch.showProductSearchModal(this)
      },
      addProductByGln() {
        this.addProductByGlnInternal('condition_products')
      },
      addProductByGlnInternal(target) {
        var gln = window.prompt(this.$i18n.t('sandoz.gln_prompt'))
        if (!gln) {
          return
        }
        axios.get(`/api/kuko_products?filter[gln]=${gln}`).then(response => {
          var products = response.data.data
          if (products.length == 0) {
            window.alert(this.$i18n.t('sandoz.invalid_gln'))
          }
          else {
            this.item[target].push(
              {
                product_id: products[0].id,
                kuko_product: products[0],
								yearly_gross_sales: null,
								chargeback_chf: null,
								chargeback_percentage: null,
								fixed_chargeback: null,
                efp: products[0].efp
              }
            )
          }
          this.loadProductKpis()
        })
      },
      productSelected(productEvent) {
        let product = productEvent.product
        let owningComponent = productEvent.owningComponent
        let owningComponentData = owningComponent.$data

        owningComponentData.item[owningComponentData.kukoProductSearchMode].push(
          {
            product_id: product.id,
            kuko_product: product,
            yearly_gross_sales: null,
            chargeback_chf: null,
            chargeback_percentage: null,
            fixed_chargeback: null,
            efp: product.efp
          }
        )
        this.loadProductKpis()
      },
      loadData() {
        this.loadChargeback()
        this.loadProductGroups()
      },
      loadProductGroups() {
        axios.get(`/api/kuko_product_groups?per_page=999`).then(response => {
          this.productGroups = response.data.data
        })
      },
      enableWatchers() {
      },
      loadChargeback() {
				this.url = `/api/chargebacks/${this.$route.params.id}?include=user,condition_product_groups,condition_product_groups.kuko_product_group,condition_products,condition_products.kuko_product,otc_product_attachments,files.user`
        axios
          .get(this.url)
          .then((response) => {
            var item = response
            if (this.dataKey) {
              item = response[this.dataKey]
            }
            this.item = item.data

            // set default user
            if (!this.item.user_id) {
              this.item.user_id = this.user.id
            }

            // set default year
            if (this.item.chargeback_year === null || this.$route.params.id === 'new') {
              this.item.chargeback_year = getCurrentYear()
            }

            this.loadKpis(this.item.external_id)
            this.loadProductKpis()

            // filter chargable condition product groups
            this.$nextTick(() => {
              this.loaded = true
              this.enableWatchers()
            })
          })
      },
      loadLegacy(newVal) {
        if(typeof newVal === 'undefined' || !newVal) {
          return
        }

        axios
          .get(`/api/kukos/legacy/${newVal}`)
          .then((response) => {
            this.legacyKukos = response.data
          })
      },
      loadKpis(newVal) {
        if(typeof newVal === 'undefined' || !newVal) {
          return
        }

        axios
          .get(`/api/kukos/kpis/${newVal}`)
          .then((response) => {
            this.kpis = response.data
          })
      },
      loadProductKpis() {
        var _self = this
        _self.eanForKpis = []
        if(_self.item.condition_products && _self.item.condition_products.length > 0) {
          _self.item.condition_products.forEach(function (product) {
            if(product.kuko_product.gln && !_self.eanForKpis.includes(product.kuko_product.gln)) {
              _self.eanForKpis.push(product.kuko_product.gln)
            }
          })
        }

        if(_self.item.condition_special_products && _self.item.condition_special_products.length > 0) {
          _self.item.condition_special_products.forEach(function (product) {
            if(product.kuko_product.gln && !_self.eanForKpis.includes(product.kuko_product.gln)) {
              _self.eanForKpis.push(product.kuko_product.gln)
            }
          })
        }

        axios
          .post(`/api/kukos/product_kpis`, {code: _self.eanForKpis})
          .then((response) => {
            this.productKpis = response.data
          })
      },
      addProductGroup(productGroup, item) {
        this.item.condition_product_groups.push(
          {
            product_group_id: productGroup.id,
            kuko_product_group: productGroup,
						yearly_gross_sales: null,
            chargeback_chf: null,
            chargeback_percentage: null,
            fixed_chargeback: null
          }
        )
      },
      addOtcAttachment (files) {
        const _self = this
        files.forEach(function (file) {
          _self.item.otc_product_attachments.push(
            {
              deleted_at: null,
              file: file.servername,
              chargeback_id: _self.$route.params.id
            }
          )
        })
      },
      addToWordFiles(evt) {
        var fileName = evt.target.value.replace(/^.*[\\/]/, '')
        var files = evt.target.files
        var file = files[0]

        if (!file) {
          return
        }

        if (file) {
          var reader = new window.FileReader()
          const self = this
          reader.onload = function (readerEvt) {
            let wordOb = {
              id : self.item.id !== 'new' && self.item.id !== undefined ? null : 'NEW_TEMP_ID_' + (++self.newFileCounter),
              chargeback_id : self.item.id,
              user_id: self.user.id,
              user: self.user,
              file_name: {
                data: readerEvt.target.result,
                name: fileName
              }
            }

            if(self.item.id !== 'new'  && self.item.id !== undefined) {
              self.uploadWordFile(wordOb)
            } else {
              self.item.files.push(wordOb);
              self.wordfile = null;
            }
          }
          reader.readAsDataURL(file)
        }
      },
      addFile() {
        this.$refs.fileinput.$refs.input.click()
      },
      word (i) {
      if (i !== null) {
        const file = this.item.files[i]
        axios.post('/api/sandoz/chargeback_file/download', {
            'id': file.id
          }, {responseType: 'arraybuffer'})
              .then((response) => {
                require('downloadjs')(
                  response.data,
                  file.file_name.name,
                  'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
                )
              }).catch((error) => {
            console.log(error)
          })
        }
      },
      deleteWordFile(id, i) {
        if(this.item.id !== 'new') {

          this.$notify({
            title: this.$i18n.t('core.saved'),
            text: this.$i18n.t('core.saved_text')
          })

          axios.delete(`/api/sandoz/chargeback_file/${id}`)
          .then((response) => {
            this.item.files.splice(i, 1)
          }).catch((error) => {
          })
        } else {
          this.item.files.splice(i, 1)
        }
      },
      uploadWordFile(obj) {
        axios.post(`/api/sandoz/chargeback_file/new?include=user`,obj)
        .then((response) => {
          this.$notify({
            title: this.$i18n.t('core.saved'),
            text: this.$i18n.t('core.saved_text')
          })

          this.item.files.push(response.data);
          this.wordfile = null;
        }).catch((error) => {
        })
      },
      getExtension(fileName) {
        if(fileName !== '') {
          var ext = fileName.split('.').pop()

          if(ext === 'doc' || ext === 'docx') {
            return 'file-word'
          } else if(ext === 'odt' || ext === 'txt') {
            return 'file-text'
          } else if(ext === 'pdf') {
            return 'file-pdf'
          } else if(ext === 'xls' || ext === 'xlsx' || ext === 'ods') {
            return 'file-excel'
          } else if(ext === 'ppt' || ext === 'pptx') {
            return 'file-powerpoint'
          }
          return 'file'
        }
      },
      filterConditionProductGroup(productGroupID) {
        var index = null
        for (var i = 0; i <  this.item.condition_product_groups.length; i++) {
            if(this.item.condition_product_groups[i].product_group_id === productGroupID) {
              index = i
              return index
            }
        }
      },
      setCurrentUser(user) {
        if (!user) {
          return
        }
        if (user.regions && user.regions.data && Object.keys(user.regions.data).length) {
          this.item.region_id = user.regions.data[0].region_id
        } else {
          this.item.region_id = null
        }
      },
			setWholesaler(wholesaler) {
				if (!wholesaler) {
          return
        }
			},
			calChargeback(product) {
				if(product.yearly_gross_sales && product.chargeback_percentage) {
					var chargeBackChf = product.yearly_gross_sales*product.chargeback_percentage	
					product.chargeback_chf = Math.round(chargeBackChf)
				} else {
					product.chargeback_chf = null
				}
			},
			calChargeback1(product, category = '') {
				if(product[category + 'portfolio_rebate_yearly_gross_sales'] && product[category + 'portfolio_rebate_chargeback_percentage']) {
          var chargeBackChf = product[category + 'portfolio_rebate_yearly_gross_sales'] * product[category + 'portfolio_rebate_chargeback_percentage']
          product[category + 'portfolio_rebate_chargeback_chf'] = Math.round(chargeBackChf)
				} else {
					product[category + 'portfolio_rebate_chargeback_chf'] = null
				}
			}
    }
  }
</script>
<style scoped>

.align-category {
  position: relative;
  top: -30px;
  left: 175px;
}
</style>
